var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataLoaded)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-lg-8"},[_c('manga_collection',{attrs:{"horizontal":false,"mangas":_vm.mangas}})],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }